import { useParams, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { Heading } from "suomifi-ui-components";
import { IconArrowLeft } from "suomifi-icons";
import { useAppState } from "../state/store";
import { naytaNimi } from "../utils/kayttajaNimi";
import HenkilollisyydenTodentaminen from "../components/HenkilollisyydenTodentaminen";
import { useGetKayttajaCustomQuery } from "../api/backendApi";
import { skipToken } from "@reduxjs/toolkit/query";
import { useTranslation } from "react-i18next";

const Page = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.l};
`;

const BackButton = styled.button`
  background: transparent;
  border: 0;
  padding: 0;
  font: ${({ theme }) => theme.typography.bodyTextSmall};
  font-size: 0.875rem;
  color: ${({ theme }) => theme.colors.highlightBase};
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.xxs};
  align-self: flex-start;

  & > svg {
    width: 1rem;
    height: 1rem;
  }

  &:hover {
    text-decoration: underline;
    color: ${({ theme }) => theme.colors.highlightDark1};
  }
`;

const Counter = styled.span`
  font-family: "Courier New", monospace;
  font-size: 0.875rem;
  color: ${({ theme }) => theme.colors.depthDark1};
`;

const TopRow = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing.m};
`;

const Card = styled.section`
  background: ${({ theme }) => theme.colors.whiteBase};
  border: 1px solid ${({ theme }) => theme.colors.depthLight1};
  padding: ${({ theme }) => theme.spacing.m};
`;

const NotFoundBox = styled.div`
  padding: ${({ theme }) => theme.spacing.xxl};
  color: ${({ theme }) => theme.colors.depthDark1};
`;

export default function KayttajanTodennusyritykset() {
  const { t } = useTranslation(["todentaminen", "common"]);
  const { uid } = useParams();
  const navigate = useNavigate();
  const { state } = useAppState();

  const { data: kayttaja } = useGetKayttajaCustomQuery(uid ?? skipToken);

  const yritykset = kayttaja?.tapahtumat.filter(
    (t) =>
      t.tyyppi === "id_proofing_onnistui" ||
      t.tyyppi === "id_proofing_epaonnistui" ||
      t.tyyppi === "id_proofing_aloitettu",
  );

  return (
    <Page>
      <BackButton onClick={() => navigate(-1)} type="button">
        <IconArrowLeft aria-hidden />
        {t("napit.takaisin")}
      </BackButton>

      <TopRow>
        <Heading variant="h1">
          {t("otsikot.todentaminen")}{" "}
          {kayttaja ? naytaNimi(kayttaja) : "Tuntematon käyttäjä"}
        </Heading>
        <Counter>
          {(yritykset ?? []).length} {t("yritysLaskuri")}
        </Counter>
      </TopRow>

      <Card>
        {kayttaja && (
          <HenkilollisyydenTodentaminen kayttaja={kayttaja} naytaKaikki />
        )}
      </Card>
    </Page>
  );
}
